//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { api, config } from '@/service'

export default {
  data() {
    return {
      vcode: `${config.baseUrl}${api.generateQRCode}`,
      rules: {
          phoneNo: [
            { required: true, message: '请输入閣下成功上台的手機號', trigger: 'change' },
            { min: 8, max: 8, message: '錯誤手機號', trigger: 'change' }
          ],
          hkCode: [
            { required: true, message: '请输入閣下成功上台的身份證號', trigger: 'change' },
            { min: 4, max: 4, message: '錯誤身分證號', trigger: 'change' }
          ],
          code: [
            { required: true, message: '輸入驗證碼', trigger: 'change' },
            { min: 4, max: 4, message: '輸入驗證碼有誤', trigger: 'change' }
          ]
      },
      form: {
        phoneNo: "",
        hkCode: "",
        code: ""
      }
    };
  },
  methods: {
    switchCode() {
        this.vcode = `${config.baseUrl}${api.generateQRCode}?code=${Math.random()}`
    },
    submit() {
        this.$http('pcOrderInfo/queryByPhone', this.form).then(res=>{
            if(res.returnCode == '1000') {
              let { customerInfo, id, phoneNo, businessType, businessPlanName, orderStatus, productOrderId } = res.dataInfo, 
                  query = {}
              if(productOrderId) query.orderId = productOrderId
              else query = {
                info: JSON.stringify({
                  customerInfo: {
                    buyerName: `${customerInfo.lastName} ${customerInfo.firstName}`
                  },
                  businessType: businessType,
                  id: id,
                  businessPhone: phoneNo,
                  businessPlan: businessPlanName,
                  paymentAmount: null,
                  payTime: null,
                  orderStatus: ({'2': '6', '3': '1', '4': '1', '5': '4', '6': '4'})[orderStatus]
                })
              }
              this.$router.push({path: '/result/info', query: query})                
            }
            // 更換驗證碼，清空驗證碼         
            this.form.code = ''
            this.$nextTick(_=>{
                this.$refs.form.clearValidate()
            })
            this.switchCode()
        })
    },
    submitForm(formName) {        
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submit()
        } else {
          return false;
        }
      });
    }
  }
};
